import { Box as MaterialBox } from '@mui/material';
import React from 'react';

import { BoxProps } from './Box.props';

export const Box: React.FC<BoxProps> = ({
  children,
  className
}) => {
  return <MaterialBox className={className}>{children}</MaterialBox>;
};